// import { useState, useRef, useEffect } from "react";
// import { InfoIcon } from "lucide-react";
// import "../../css/ChartInfoPopup.css";

// export default function ChartInfoPopup({ text }) {
//   const [open, setOpen] = useState(false);
//   const ref = useRef();

//   useEffect(() => {
//     const close = (e) => {
//       if (ref.current && !ref.current.contains(e.target)) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("click", close);
//     return () => document.removeEventListener("click", close);
//   }, []);

//   return (
//     <div ref={ref} className="chart-info-trigger">
//       <InfoIcon
//         size={18}
//         onClick={() => setOpen(!open)}
//         className="chart-info-icon"

//       />

//       {open && (
//         <div className="chart-info-popup">
//           {text}
//           <div className="chart-info-arrow"></div>
//         </div>
//       )}
//     </div>
//   );
// }

import { useState, useRef, useEffect } from "react";
import { InfoIcon } from "lucide-react";
import "../../css/ChartInfoPopup.css";

export default function ChartInfoPopup({ text }) {
  const [open, setOpen] = useState(false);
  const [theme, setTheme] = useState(
    localStorage.getItem("theme")?.toLowerCase().includes("dark")
      ? "dark"
      : "light"
  );
  const ref = useRef();

  useEffect(() => {
    const handler = () => {
      const saved = localStorage.getItem("theme");
      setTheme(saved?.toLowerCase().includes("dark") ? "dark" : "light");
    };

    window.addEventListener("themeChanged", handler);
    return () => window.removeEventListener("themeChanged", handler);
  }, []);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  return (
    <div ref={ref} className="chart-info-trigger">
      <InfoIcon size={18} onClick={() => setOpen(!open)} className="chart-info-icon" />
      {open && (
        <div className={`chart-info-popup ${theme}`}>
          {text}
          <div className={`chart-info-arrow ${theme}`} />
        </div>
      )}
    </div>
  );
}
